import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStackedColumnChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.79995 10.3081C7.47886 10.3078 7.21435 10.5073 7.19995 10.761L7.19995 19.8339C7.19995 20.0959 7.46864 20.3081 7.79995 20.3081C8.13126 20.3081 8.39995 20.0959 8.39995 19.8339L8.39995 10.761C8.38555 10.5073 8.12105 10.3078 7.79995 10.3081Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2004 3.85791C13.0344 3.86407 12.8784 3.9226 12.7659 4.02063C12.6537 4.11867 12.5943 4.24818 12.6008 4.38104L12.6008 19.825C12.6008 20.0902 12.8693 20.305 13.2003 20.305C13.5314 20.305 13.7999 20.0902 13.7999 19.825L13.7999 4.38104C13.8064 4.24819 13.747 4.11868 13.6348 4.02063C13.5223 3.9226 13.3663 3.86407 13.2003 3.85791H13.2004Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9006 8.15686C15.7296 8.16798 15.5709 8.23253 15.4589 8.33673C15.3468 8.44093 15.2905 8.57633 15.302 8.7136L15.302 19.828C15.302 20.093 15.5701 20.308 15.9006 20.308C16.2312 20.308 16.4993 20.093 16.4993 19.828L16.4993 8.7112C16.5099 8.57432 16.4533 8.43945 16.3414 8.3358C16.2293 8.23214 16.0712 8.16786 15.9006 8.15674L15.9006 8.15686Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5001 1C10.1791 0.999732 9.91455 1.20183 9.90015 1.45843L9.90015 19.828C9.90015 20.0932 10.1688 20.308 10.5001 20.308C10.8315 20.308 11.1001 20.0932 11.1001 19.828L11.1001 1.45843C11.0857 1.20183 10.8212 0.999726 10.5001 1V1Z",
			fill: "var(--colors-grey-1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2 22.5586C2 22.1444 2.33579 21.8086 2.75 21.8086L21.25 21.8086C21.6642 21.8086 22 22.1444 22 22.5586C22 22.9728 21.6642 23.3086 21.25 23.3086L2.75 23.3086C2.33579 23.3086 2 22.9728 2 22.5586Z",
			fill: "var(--colors-grey-1)"
		})
	]
});
export default SvgStackedColumnChart;
